<template>
    <vcarousel :data="list" class="lg" :controls="!hideControls && this.images.length > 1" :indicators="!hideIndicators && this.images.length > 1" indicator-type="disc"></vcarousel>
</template>

<script>
import MobileDetector from '../../common/MobileDetector'

export default {
  name: 'BigCarousel',
  mixins: [MobileDetector],
  props: {
    images: {
      type: Array,
      default: () => []
    },
    hideControls: {
      type: Boolean,
      value: false
    },
    hideIndicators: {
      type: Boolean,
      value: false
    }
  },
  computed: {
    list () {
      return this.images.map(image => {
        return `<div class="slide image-contain" style="width: 100%; height: ${this.isMobile ? '250px' : '400px'}" :style="\`background-image: url(${image})\`"></div>`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/BigCarousel.vue